<template>
  <div class="statistics-card">
    <span class="statistics-card__title">{{ title }}</span>
    <div class="statistics-card__value">{{ commna }}</div>
    <!-- {{ value }} -->
  </div>
</template>
<script>
import { numberWithCommas } from "@/components/utils.js";

export default {
  name: "StatisticsCard",
  data: () => ({
    delayValue: 0,
  }),
  props: {
    title: String,
    value: [Number, String],
    raf: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    commna() {
      return numberWithCommas(this.value);
    },
  },

  watch: {
    value(nVal) {
      if (nVal) {
        this.delayValue = this.value;
      }
    },
  },
};
</script>
<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.statistics-card {
  width: 250px;
  padding: 16px 24px;
  text-align: center;

  &__title {
    font-size: 15px;
    color: #595959;
  }

  &__value {
    margin-top: 12px;
    font-size: 24px;
    font-weight: 500;
  }
}

@media (max-width: $min_layout) {
  .statistics-card {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__value {
      margin-top: 0;
      margin-left: 0;
    }
  }
}
</style>
